import Environment from '../../Environment';
import { IUri, buildUrl } from '../BaseService';

export function prepareUrl({
  filters,
  queries,
  id,
  includes,
  resource,
}: IUri): string {
  return buildUrl({
    host: Environment.chatService,
    resource,
    queries,
    filters,
    includes,
    id,
  });
}
